import React from 'react';
import ReactDOM from 'react-dom/client';
import './styles/App.css';
import './index.css';
import App from './App';
import './i18n';
import { GlobalWrapper } from 'contexts/GlobalWrapper';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
  <React.StrictMode>
    <GlobalWrapper>
      <App/>
    </GlobalWrapper>
  </React.StrictMode>
); 